const QUANTITY_ON_CHANGE = 'QUANTITY_ON_CHANGE';
const QUANTITY_RESET = 'QUANTITY_ON_RESET';
const BUNDLE_QUANTITY_ON_CHANGE = 'BUNDLE_QUANTITY_ON_CHANGE';
const BUNDLE_QUANTITY_ON_RESET = 'BUNDLE_QUANTITY_ON_RESET';

export default {
    QUANTITY_ON_CHANGE,
    QUANTITY_RESET,
    BUNDLE_QUANTITY_ON_CHANGE,
    BUNDLE_QUANTITY_ON_RESET,
};
